<script setup lang="ts">
import { computed } from "vue";

const TOP_GAP_PX = 2;
const SIDE_GAP_PX = 2;

const props = defineProps<{
  itemSidePadding: number;
  level: number;
  indentationPx: number;
}>();

const left = computed(
  () => `${props.itemSidePadding + (props.level - 2) * props.indentationPx + props.indentationPx / 2}px`
);
const width = computed(() => `${props.indentationPx / 2 - SIDE_GAP_PX}px`);
</script>

<template>
  <div
    class="absolute rounded-bl border-b border-l border-md"
    :style="{ left, top: `${TOP_GAP_PX}px`, bottom: '10%', width }" />
</template>
